<template>
  <span>
    <v-btn
        icon
        @click="open"
    >
      <v-icon>mdi-pencil</v-icon>
    </v-btn>
  <v-dialog
      v-model="dialog"
      persistent
      fullscreen
      eager
  >
        <v-toolbar
            dark
            full-screen
            color="primary"
        >
          <v-btn
              icon
              dark
              @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit position</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
                dark
                text
                @click="save"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
    <v-card>
      <v-card-text>
        <v-row justify="center">
      <v-col cols="3">
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                      v-model="title"
                      label="Company Name"
                      required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                      v-model="symbol"
                      label="Company Symbol"
                      required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                      solo
                      label="Summary"
                      v-model="summary"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                      label="Position Cost"
                      v-model="positionCost"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
      </v-col>
      <v-col cols="6">
        <v-timeline
            align-top
            dense
        >
        <v-timeline-item
            v-for="(message, index) in messages"
            :key="index"
            :color="message.color"
            small
        >
            <div class="font-weight-normal">
              <strong>{{ message.symbol }} - {{ message.action }}: ${{ message.price }}</strong>  @ {{ message.time }}
                <v-btn icon v-if="positionId === -1" @click="moveMessageUp(index)">
                <v-icon>mdi-chevron-triple-up</v-icon>
              </v-btn>
              <v-btn icon v-if="positionId === -1" @click="moveMessagesDown(index)">
                <v-icon>mdi-chevron-triple-down</v-icon>
              </v-btn>
              <v-btn icon @click="editMessage(index)" v-if="positionId === -1">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon v-if="positionId === -1" @click="deleteMessage(index)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
        </v-timeline-item>
        </v-timeline>
      </v-col>
          <v-col cols="3">
            <v-form>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                        v-model="positionObj.symbol"
                        label="Symbol"
                        required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-select
                        :items="actions"
                        v-model="positionObj.action"
                        label="Action"
                        solo
                        required
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                        v-model="positionObj.price"
                        label="Price"
                        required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="positionObj.time"
                        persistent
                        width="290px"
                    >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              v-model="positionObj.time"
              label="Order Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="date"
            scrollable
        >
          <v-spacer></v-spacer>
          <v-btn
              text
              color="primary"
              @click="modal = false"
          >
            Cancel
          </v-btn>
          <v-btn
              text
              color="primary"
              @click="$refs.dialog.save(date)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-select
                        :items="colors"
                        v-model="positionObj.color"
                        label="Colour"
                        solo
                        required
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <v-btn color="primary" @click="saveMessage" v-if="positionId !== -1">
                Save
              </v-btn>
              <v-btn color="primary" @click="addMessage" v-if="positionId === -1">
                Add Item
              </v-btn>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
  </span>
</template>

<script>
import PositionTimeline from "@/components/PositionTimeline";

function bumpUp(list, selectedItemIndex) {
  if (selectedItemIndex < 0) {
    return list;
  }

  if (selectedItemIndex === 0) {
    return list;
  }

  let selectedItem = null;
  let selectedItem2 = null;

  list.forEach((item, index) => {
    if (item.order === selectedItemIndex) {
      selectedItem = index;
    }
    if (item.order === selectedItemIndex - 1) {
      selectedItem2 = index;
    }
  })

  list[selectedItem].order -= 1;
  list[selectedItem2].order += 1;

  return list;
}

function bumpDown(list, selectedItemIndex) {
  if (selectedItemIndex > list.length - 1) {
    return list;
  }

  if (selectedItemIndex === list.length - 1) {
    return list;
  }

  let selectedItem = null;
  let selectedItem2 = null;

  list.forEach((item, index) => {
    if (item.order === selectedItemIndex) {
      selectedItem = index;
    }
    if (item.order === selectedItemIndex + 1) {
      selectedItem2 = index;
    }
  })

  list[selectedItem].order += 1;
  list[selectedItem2].order -= 1;

  return list;
}

export default {
  name: "EditDetailsComponent",
  components: {PositionTimeline},
  props: [
    'item',
    'position'
  ],
  data() {
    return {
      dialog: false,
      summary: '',
      symbol: '',
      title: '',
      positionCost: 0,
      messages: [],
      positionObj: {
        symbol: '',
        action: '',
        price: 0,
        time: '',
        color: '',
        order: 0
      },
      positionId: -1,
      actions: ['long', 'short'],
      colors: ['orange', 'green', 'red']
    }
  },
  methods: {
    save() {
      this.dialog = false;
      this.$store.commit('updatePosition', {
        position: this.position,
        obj: {
          title: this.title,
          summary: this.summary,
          symbol: this.symbol,
          messages: this.messages,
          positionCost: parseFloat(this.positionCost)
        }
      })
    },
    saveMessage() {
      this.messages[this.positionId].symbol = this.positionObj.symbol;
      this.messages[this.positionId].action = this.positionObj.action;
      this.messages[this.positionId].price = parseFloat(this.positionObj.price);
      this.messages[this.positionId].time = this.positionObj.time;
      this.messages[this.positionId].color = this.positionObj.color;

      this.positionId = -1;
    },
    open() {
      this.dialog = true;
      this.title = this.item.title;
      this.summary = this.item.summary;
      this.symbol = this.item.symbol;
      this.messages = this.item.messages;
      this.positionCost = this.item.positionCost;
    },
    editMessage(index) {
      this.positionId = index;

      let m = this.messages[index];
      this.positionObj.action = m.action;
      this.positionObj.order = m.order;
      this.positionObj.color = m.color;
      this.positionObj.price = m.price;
      this.positionObj.symbol = m.symbol;
      this.positionObj.time = m.time;
    },
    deleteMessage(index) {
      this.messages.splice(index, 1);
    },
    moveMessageUp(index) {
      this.messages = bumpUp(this.messages, index);
    },
    moveMessagesDown(index) {
      this.messages = bumpDown(this.messages, index);
    },
    addMessage() {
      this.positionId = this.messages.length;
      this.messages.push({
        order: this.messages.length
      });
      this.messages[this.positionId].symbol = this.positionObj.symbol;
      this.messages[this.positionId].action = this.positionObj.action;
      this.messages[this.positionId].price = parseFloat(this.positionObj.price);
      this.messages[this.positionId].time = this.positionObj.time;
      this.messages[this.positionId].color = this.positionObj.color;
      this.positionId = -1;
    }
  }
}
</script>

<style scoped>

</style>